/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */

import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';
import { omit } from 'underscore';

import { UNDO_REFUSAL_REQUEST, success, failure } from './action';

const undoRequestRefusal = (action$, state$, { AjaxRequest }) =>
  action$
    .ofType(UNDO_REFUSAL_REQUEST)
    .map(({ payload }) => payload)
    .mergeMap((payload) =>
      AjaxRequest.open('post', `/admin/contractcustom/contracts/${payload.contractId}/undorequestrefusal`, {
        ...omit(payload, 'contractId'),
      })('tudo')
        .flatMap(({ response }) => Observable.of(success(response.resource)))
        .catch((err) => Observable.of(failure(err))),
    );

export default combineEpics(undoRequestRefusal);
